/*
// project imports
import applications from './applications';
import widget from './widget';
import formsTables from './forms-tables';
import samplePage from './sample-page';
import chartsMap from './charts-map';
import other from './other';
import pages from './pages';
import flowsign from './flowsign';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  //items: [flowsign, widget, applications, formsTables, chartsMap, samplePage, pages, other]
  items: [flowsign]
};

export default menuItems;
*/

import { useMemo } from 'react';

// project imports
import { usePermissions } from 'hooks/usePermissions';
import { filterMenuItemsByPermissions } from 'utils/filterMenuItems';
//import modules from './modules';
import flowsign from './flowsign';
import axiusUsersConfig from './users';

// ==============================|| MENU ITEMS ||============================== //

export default function useMenuItems() {
  const { hasAnyPermission, hasAnyRole } = usePermissions();

  const menuItems = useMemo(() => {
    const allItems = {
      items: [flowsign, axiusUsersConfig]
    };

    return {
      items: filterMenuItemsByPermissions(allItems.items, hasAnyPermission, hasAnyRole)
    };
  }, [hasAnyPermission, hasAnyRole]);

  return menuItems;
}
